import {Nomenclature} from './Nomenclature';
import {FrxBaseBean} from './frxbasebean';
export class Payment extends FrxBaseBean {
	lawsuiteId: number;
	amount: number;
	note: string;
	paymentGround: Nomenclature;

}
